import React from 'react';

import { Suspense } from '@lumapps/lumx-suspense/components/Suspense';
import { useLocation } from '@lumapps/router';
import { generateUUID } from '@lumapps/utils/string/generateUUID';

import { type MicroAppProps } from '../../types';

const LazyMicroApp = React.lazy(
    () =>
        import(
            /* webpackChunkName: 'micro-app' */
            './MicroApp'
        ),
);

const SCOPE = 'micro-app';

export const MicroApp: React.FC<MicroAppProps> = (props) => {
    const { key } = useLocation();
    // runInstanceId is not available outside layout
    const uniqueInstanceId = React.useMemo(() => `${key}-${generateUUID()}`, [key]);

    return (
        <Suspense>
            <LazyMicroApp
                key={`${SCOPE}-${props?.runInstanceId || uniqueInstanceId}`}
                runInstanceId={props?.runInstanceId || uniqueInstanceId}
                {...props}
            />
        </Suspense>
    );
};

MicroApp.displayName = 'MicroApp';
